import React from 'react';
import PropTypes from 'prop-types';

const MiddleName = props => <span>{props.data.middle_name}</span>;

MiddleName.propTypes = {
	data: PropTypes.object.isRequired,
};

export default MiddleName;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/people/parts/middle-name.js